import React, { Component, useRef } from "react";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { TextField } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import successIcon from "../../../../../Assets/img/svg/Check.svg";
import del from "../../../../../Assets/img/svg/Del.svg";
import Delete from "../../../../../Assets/img/svg/delete.svg";
import errorIcon from "../../../../../Assets/img/svg/cancelerror.svg";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import { Tooltip } from "@material-ui/core";
import styles from "../../../../../Assets/jss/customStyle";
import { withStyles } from "@material-ui/core/styles";
import moment from "moment";
import axios from "axios";
import API from "../../../../../helpers/endpointService";
import { inspectionSystem } from "../../../../Constants";
import { CssTextField } from "../../../../custom/textField";
import { warningAlert, successAlert } from "../../../../custom/alert";
import { errorToast } from "../../../../../actions/CommonFunction";
import Role from "../../../../../helpers/role";
import Autocomplete from "react-autocomplete";

class AddEditCargoBulker extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      successId: 0,
      isSuccess: false,
      isFailure: false,
      isSuccessComment: false,
      isFailureComment: false,
      CommentId: "",
      ShipId: 0,
      UserRole: "",
      User: "",
      baleCapacity: 0,
      grainCapacity: 0,
      locationFrame: 0,
      isMobile: false,
      isView: false,
      DocsName: [],
      CargoBulk: [],
      currentQuesId: 0,
      NewQuestions: [],
      CargoBulkComments: "",
      isAddModal: false,
      isDeleteModal: false,
      selectedHoldIds: [],
      cargoResponse: [],
      addCargoOptions: [],
      selectedCargo: null,
      cargoAddError: false,
      errorMessage: "",
      isErrorPopup: false,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.state.ShipId = localStorage.getItem("DashId");
    this.state.UserRole = localStorage.getItem("UserRoles");
    this.state.InspectionId = parseInt(localStorage.getItem("InspectionId"));
    this.state.User = localStorage.getItem("UserRoles");
    this.setState({});
    this.CargoBulkerTable();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#TrainModule1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#TrainModule").addClass("d-none");
    $("#TrainModule").removeClass("d-block");
    $("#TML").removeClass("active-color");
    $("#TMT").removeClass("fw-bolder");
  }

  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };
  resize1 = () => {
    $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#TrainModule1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#TrainModule").removeClass("d-none");
    $("#TrainModule").addClass("d-block");
    $("#TML").addClass("active-color");
    $("#TMT").addClass("fw-bolder");
  };
  sidebar = () => {
    this.props.navigate("/sidebar");
  };

  OpenPopup = () => {
    window.$("#deletepopup").modal("show");
  };
  handleInputChange = (e, str) => {
    this.state.successId = str.QuestionId;
    this.state.isSuccess = false;
    this.state.isFailure = false;
    this.setState({});
    this.state.CargoBulk &&
      this.state.CargoBulk?.Questions?.map((i, ind) =>
        i.Id == str.Id ? (str.CheckId = e.target.value) : ""
      );
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: parseInt(e.target.value),
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: "",
      MultipleAnswerIds: "",
      CreatedBy: this.state.User,
    };
    if (data.Id === 0) {
      this.post_bulkerStatus(data);
    } else {
      this.put_bulkerStatus(data, data?.Id);
    }
  };
  post_bulkerStatus = (data) => {
    let apiUrl = `${API.AddEdit_checklist}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.CargoBulkerTable();
          this.setState({ isSuccess: true });
          setTimeout(() => {
            if (this.state.isSuccess === true) {
              this.setState({ isSuccess: false, successId: 0 });
            }
          }, 2000);
        } else {
          this.setState({ isFailure: true });
          setTimeout(() => {
            if (this.state.isFailure === true) {
              this.setState({ isFailure: false, successId: 0 });
            }
          }, 3000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        this.setState({ isFailure: true });
        setTimeout(() => {
          if (this.state.isFailure === true) {
            this.setState({ isFailure: false, successId: 0 });
          }
        }, 3000);
        if (error?.response?.status === 401) {
        }
      });
  };
  put_bulkerStatus = (data, Id) => {
    let apiUrl = `${API.AddEdit_checklist}?id=${Id}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.CargoBulkerTable();
          this.setState({ isSuccess: true });
          setTimeout(() => {
            if (this.state.isSuccess === true) {
              this.setState({ isSuccess: false, successId: 0 });
            }
          }, 2000);
        } else {
          this.setState({ isFailure: true });
          setTimeout(() => {
            if (this.state.isFailure === true) {
              this.setState({ isFailure: false, successId: 0 });
            }
          }, 3000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        this.setState({ isFailure: true });
        setTimeout(() => {
          if (this.state.isFailure === true) {
            this.setState({ isFailure: false, successId: 0 });
          }
        }, 3000);
        if (error?.response?.status === 401) {
        }
      });
  };
  handleInputChange1 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.state.isSuccess = false;
    this.state.isFailure = false;
    this.setState({});
    this.state.CargoBulk &&
      this.state.CargoBulk?.Questions?.map((i, ind) =>
        i.AnswerId == str.AnswerId ? (str.Answer = e.target.value) : ""
      );
    this.setState({});
  };
  updatemastercomments = (e, str) => {
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: e.target.value.trim(),
      MultipleAnswerIds: "",
      CreatedBy: this.state.User,
    };
    if (data.Id === 0) {
      this.post_bulkerStatus(data);
    } else {
      this.put_bulkerStatus(data, data.Id);
    }
  };

  openAddModal = () => {
    let value = this.getMissingQuestions(
      this.state.cargoResponse,
      this.state.NewQuestions
    );
    console.log(value);
    this.setState({
      isAddModal: true,
      addCargoOptions: value,
      cargoAddError: false,
    });
  };
  handleAddCargoChange = (option) => {
    this.setState({ selectedCargo: option });
  };

  closeAddModal = () => {
    this.setState({
      isAddModal: false,
      selectedCargo: null,
      addCargoOptions: [],
      cargoAddError: false,
      selectedHoldIds: [],
    });
  };
  closeDeleteModal = () => {
    this.setState({
      isDeleteModal: false,
      selectedHoldIds: [],
    });
  };

  handleDelete = (id, index) => {
    let arrayId = [];
    arrayId.push(id);
    let prevId = this.state.CargoBulk.Questions[index - 1].QuestionId;
    if (prevId) {
      arrayId.push(prevId);
    }

    const remainingQuestions = this.state.NewQuestions.filter(
      (q) => !arrayId.includes(q.QuestionId)
    );

    const remainingIds = remainingQuestions.map((q) => q.QuestionId);
    console.log(arrayId);
    console.log(remainingIds);
    this.setState({ selectedHoldIds: remainingIds, isDeleteModal: true });
  };

  deleteFunction = () => {
    this.updateQuestionData(this.state.selectedHoldIds);
    this.closeDeleteModal();
  };

  handleAddCargo = () => {
    if (this.state.selectedCargo) {
      this.setState({ cargoAddError: false });
      let value = this.addSelectedQuestions(
        this.state.selectedCargo.QuestionIds,
        this.state.cargoResponse,
        this.state.NewQuestions
      );
      console.log(value);
      const remainingIds = value.map((q) => q.QuestionId);
      this.closeAddModal();
      this.updateQuestionData(remainingIds);
      // console.log(remainingIds);
      // this.setState({ NewQuestions: value });
      // let cargovalue = this.updateQuestions(this.state.cargoResponse, value);
      // if (cargovalue) {
      //   this.setState({ CargoBulk: cargovalue, isAddModal: false });
      // }
    } else {
      this.setState({ cargoAddError: true });
    }
  };

  updateQuestionData = (ids) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let data1 = {
      QuestionIds: ids,
      ModifiedBy: currentUser.email,
    };
    let apiUrl = `${API.UpdateQuestions}?inspectionId=${this.state.InspectionId}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "PUT",
      url: apiUrl,
      data: data1,
    })
      .then((res) => {
        if (res) {
          this.CargoBulkerTable();
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        console.log(error);
      });
  };
  addSelectedQuestions(selectedQuestionIds, apiResponse, newData) {
    if (!apiResponse || !apiResponse.Questions) return newData;

    // Get the questions from API that match the selected IDs
    const selectedQuestions = apiResponse.Questions.filter((q) =>
      selectedQuestionIds.includes(q.QuestionId)
    );

    // Create a set of existing QuestionIds in newData to avoid duplicates
    const existingIds = new Set(newData.map((q) => q.QuestionId));

    // Filter out duplicates
    const questionsToAdd = selectedQuestions.filter(
      (q) => !existingIds.has(q.QuestionId)
    );

    // Merge with existing newData
    const updatedData = [...newData, ...questionsToAdd];

    // Sort by OrderId
    updatedData.sort((a, b) => a.OrderId - b.OrderId);

    return updatedData;
  }

  getMissingQuestions(apiResponse, newQuestions) {
    if (!apiResponse || !apiResponse.Questions) return [];

    // Take the first 10 questions from API
    const firstTenQuestions = apiResponse.Questions.slice(0, 18);

    // Create a set of existing QuestionIds from newQuestions
    const existingQuestionIds = new Set(newQuestions.map((q) => q.QuestionId));

    // Filter missing questions
    const missingQuestions = firstTenQuestions.filter(
      (q) => !existingQuestionIds.has(q.QuestionId)
    );

    // Group by "No X Cargo Hold" pattern from QuestionDescription
    const grouped = {};

    missingQuestions.forEach((q) => {
      // Extract "No X" from description, e.g., "No 1 Lower Hold" → "No 1 Cargo Hold"
      const match = q.QuestionDescription.match(/(No \d+)/);
      const holdName = match ? `${match[1]} Cargo Hold` : q.QuestionDescription;

      if (!grouped[holdName]) {
        grouped[holdName] = [];
      }
      grouped[holdName].push(q.QuestionId);
    });

    // Convert grouped object to array
    const result = Object.keys(grouped).map((key) => ({
      name: key,
      QuestionIds: grouped[key],
    }));

    return result;
  }

  updateQuestions(response, newArray) {
    if (!response || !Array.isArray(response.Questions)) {
      console.error("Invalid response structure");
      return response;
    }

    // Clone to avoid mutating original
    const updated = { ...response, Questions: [...response.Questions] };

    if (Array.isArray(newArray) && newArray.length > 0) {
      // Remove first 10 items
      updated.Questions.splice(0, 18);
      // Append new items
      updated.Questions = [...newArray, ...updated.Questions];
    }

    return updated;
  }

  CargoBulkerTable = async () => {
    let apiUrl1 = `${API.Get_ChecklistByInspection}?sectionId=${inspectionSystem.VesselCapabilitiesandCargoSystemBulk}&inspectionId=${this.state.InspectionId}`;
    let newQuestionData = [];
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    try {
      const responseInspection = await axios.get(apiUrl1);
      if (responseInspection.data) {
        newQuestionData = responseInspection?.data?.Questions || [];
      }
      console.log("First API success:", responseInspection.data);
    } catch (error) {
      console.error("First API failed:", error);
    }
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.VesselCapabilitiesandCargoSystemBulk}&inspectionId=${this.state.InspectionId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        newQuestionData =
          newQuestionData.length > 0
            ? newQuestionData
            : response.data.Questions.slice(0, 18);
        if (response?.status === 200) {
          let newData = this.updateQuestions(response.data, newQuestionData);
          console.log(newData);
          this.setState(
            {
              CargoBulk: newData,
              cargoResponse: response?.data,
              NewQuestions: newQuestionData,
              // CargoBulk: response?.data,
            },
            () => {
              $.each(this.state.CargoBulk?.Questions, function (i, val) {
                $(".cargobulker input[value='" + val.CheckId + "']").prop(
                  "checked",
                  true
                );
              });
              this.GetCargoComments();
              this.state.CargoBulk?.Questions.map(
                (i) => (
                  i.AnswersList?.sort((a, b) => {
                    return a.CategoryId - b.CategoryId;
                  }),
                  i.AnswersList?.map((c) =>
                    c.AnswerLookupList?.sort((s, a) => {
                      return s.Id - a.Id;
                    })
                  ),
                  i.AnswersList1?.sort((a, b) => {
                    return a.CategoryId - b.CategoryId;
                  }),
                  i.AnswersList1?.map((c) =>
                    c.AnswerLookupList?.sort((s, a) => {
                      return s.Id - a.Id;
                    })
                  )
                )
              );
              // this.state.CargoBulk?.Questions.sort((s, a) => {
              //   return s.OrderId - a.OrderId;
              // });newQuestionData
              let baleCapacity = 0;
              let grainCapacity = 0;
              let locationFrame = 0;
              // this.state.CargoBulk &&
              //   this.state.CargoBulk?.Questions?.map((i, ind) =>
              //     ind < 18
              //       ? i.AnswersList1?.map((a) =>
              //           a?.AnswerLookupList[0]?.Answer != "" &&
              //           a?.AnswerLookupList[0]?.Answer > 0
              //             ? a.CategoryName === "Capacity (m³) Bale"
              //               ? (this.state.baleCapacity += parseInt(
              //                   a?.AnswerLookupList[0]?.Answer
              //                 ))
              //               : a.CategoryName === "Capacity (m³) Grain"
              //               ? (this.state.grainCapacity += parseInt(
              //                   a?.AnswerLookupList[0]?.Answer
              //                 ))
              //               : a.CategoryName === "Location Frame"
              //               ? (this.state.locationFrame += parseInt(
              //                   a?.AnswerLookupList[0]?.Answer
              //                 ))
              //               : 0
              //             : 0
              //         )
              //       : ""
              //   );
              this.state.CargoBulk &&
                this.state.CargoBulk?.Questions?.map((i, ind) =>
                  newQuestionData.length > 0
                    ? ind < newQuestionData.length
                      ? i.AnswersList1?.map((a) =>
                          a?.AnswerLookupList[0]?.Answer != "" &&
                          a?.AnswerLookupList[0]?.Answer > 0
                            ? a.CategoryName === "Capacity (m³) Bale"
                              ? (baleCapacity += parseInt(
                                  a?.AnswerLookupList[0]?.Answer
                                ))
                              : a.CategoryName === "Capacity (m³) Grain"
                              ? (grainCapacity += parseInt(
                                  a?.AnswerLookupList[0]?.Answer
                                ))
                              : a.CategoryName === "Location Frame"
                              ? (locationFrame += parseInt(
                                  a?.AnswerLookupList[0]?.Answer
                                ))
                              : 0
                            : 0
                        )
                      : ""
                    : ind < 18
                    ? i.AnswersList1?.map((a) =>
                        a?.AnswerLookupList[0]?.Answer != "" &&
                        a?.AnswerLookupList[0]?.Answer > 0
                          ? a.CategoryName === "Capacity (m³) Bale"
                            ? (baleCapacity += parseInt(
                                a?.AnswerLookupList[0]?.Answer
                              ))
                            : a.CategoryName === "Capacity (m³) Grain"
                            ? (grainCapacity += parseInt(
                                a?.AnswerLookupList[0]?.Answer
                              ))
                            : a.CategoryName === "Location Frame"
                            ? (locationFrame += parseInt(
                                a?.AnswerLookupList[0]?.Answer
                              ))
                            : 0
                          : 0
                      )
                    : ""
                );

              this.setState({
                baleCapacity: baleCapacity,
                grainCapacity: grainCapacity,
                locationFrame: locationFrame,
              });
            }
          );
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };
  handleInputCommentChange = (e, field) => {
    if (field === "CargoBulk") {
      this.state.CargoBulkComments = e.target.value;
    }
    this.state.CommentId = field;
    this.setState({});
  };
  updateOperationalComments = (e, field) => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    let shipId = parseInt(this.state.ShipId);
    let data = {
      shipId: shipId,
      sectionId: 0,
      comments: "",
      modifiedBy: currentUser.email,
    };
    if (field === "CargoBulk") {
      data.sectionId = inspectionSystem.VesselCapabilitiesandCargoSystemBulk;
      data.comments = this.state.CargoBulkComments;
    }
    this.UpdateChecklistComments(data);
  };
  UpdateChecklistComments = (data) => {
    let apiUrl = `${API.AddEdit_checklist_comments}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.GetCargoComments();
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
          this.setState({ isSuccessComment: true });
          setTimeout(() => {
            this.setState({ isSuccessComment: false, CommentId: 0 });
          }, 3000);
        } else {
          this.setState({ isFailureComment: true });
          setTimeout(() => {
            this.setState({ isFailureComment: false, CommentId: 0 });
          }, 3000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
          this.setState({ isFailureComment: true });
          setTimeout(() => {
            this.setState({ isFailureComment: false, CommentId: 0 });
          }, 3000);
        }
      });
  };

  GetCargoComments = () => {
    let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.VesselCapabilitiesandCargoSystemBulk}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.CargoBulkComments = response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };
  handleInputChange2 = (e, str, Id, Name) => {
    const value = e.target.value;

    // Copy CargoBulk deeply to avoid state mutation
    const updatedCargo = JSON.parse(JSON.stringify(this.state.CargoBulk));

    updatedCargo.Questions = updatedCargo.Questions.map((question) => {
      if (question.QuestionId !== str.QuestionId) return question;

      // Update or add new answer
      const existingCategory = question.AnswersList1?.find(
        (a) => a.CategoryId === Id
      );

      if (existingCategory) {
        existingCategory.AnswerLookupList[0].Answer = value;
      } else {
        const newEntry = {
          Id: 0,
          CategoryId: Id,
          CategoryName: Name,
          AnswerLookupList: [{ Id: 0, Answer: value }],
        };
        question.AnswersList1 = [...(question.AnswersList1 || []), newEntry];
      }

      // Sort categories and answers
      question.AnswersList1?.sort((a, b) => a.CategoryId - b.CategoryId);
      question.AnswersList1?.forEach((c) =>
        c.AnswerLookupList?.sort((s, a) => s.Id - a.Id)
      );

      return question;
    });

    // Recalculate totals
    let baleCapacity = 0;
    let grainCapacity = 0;
    let locationFrame = 0;

    updatedCargo.Questions.forEach((q, ind) => {
      const validQuestions =
        this.state.NewQuestions.length > 0
          ? ind < this.state.NewQuestions.length
          : ind < 18;

      if (validQuestions) {
        q.AnswersList1?.forEach((a) => {
          const ans = parseInt(a?.AnswerLookupList?.[0]?.Answer || 0);
          if (!isNaN(ans) && ans > 0) {
            if (a.CategoryName === "Capacity (m³) Bale") baleCapacity += ans;
            else if (a.CategoryName === "Capacity (m³) Grain")
              grainCapacity += ans;
            else if (a.CategoryName === "Location Frame") locationFrame += ans;
          }
        });
      }
    });

    this.setState(
      {
        CargoBulk: updatedCargo,
        baleCapacity,
        grainCapacity,
        locationFrame,
        successId: str.QuestionId,
        isSuccess: false,
        isFailure: false,
      },
      () => {
        console.log(this.state.CargoBulk.Questions[9]);
      }
    );
  };

  // handleInputChange2 = (e, str, Id, Name) => {
  //   console.log(Id);
  //   this.state.successId = str.QuestionId;
  //   this.state.isSuccess = false;
  //   this.state.isFailure = false;
  //   this.setState({});
  //   var data = {
  //     Id: 0,
  //     CategoryId: Id,
  //     CategoryName: Name,
  //     AnswerLookupList: [{ Id: 0, Answer: e.target.value }],
  //   };
  //   this.state.CargoBulk &&
  //     this.state.CargoBulk?.Questions?.map((i, ind) =>
  //       i.QuestionId == str.QuestionId
  //         ? i?.AnswersList1 === null || i?.AnswersList1.length === 0
  //           ? i?.AnswersList1.push(data)
  //           : i?.AnswersList1.length > 0
  //           ? i?.AnswersList1?.map((a, indexs) =>
  //               a.CategoryId === Id
  //                 ? (a.AnswerLookupList[0].Answer = e.target.value)
  //                 : i?.AnswersList1.push(data)
  //             )
  //           : i?.AnswersList1.push(data)
  //         : ""
  //     );
  //   this.setState({});
  //   this.state.CargoBulk?.Questions.map(
  //     (i) => (
  //       i.AnswersList?.sort((a, b) => {
  //         return a.CategoryId - b.CategoryId;
  //       }),
  //       i.AnswersList?.map((c) =>
  //         c.AnswerLookupList?.sort((s, a) => {
  //           return s.Id - a.Id;
  //         })
  //       ),
  //       i.AnswersList1?.sort((a, b) => {
  //         return a.CategoryId - b.CategoryId;
  //       }),
  //       i.AnswersList1?.map((c) =>
  //         c.AnswerLookupList?.sort((s, a) => {
  //           return s.Id - a.Id;
  //         })
  //       )
  //     )
  //   );
  //   // this.state.CargoBulk?.Questions.sort((s, a) => {
  //   //   return s.OrderId - a.OrderId;
  //   // });
  //   this.setState({});
  //   let baleCapacity = 0;
  //   let grainCapacity = 0;
  //   let locationFrame = 0;
  //   // this.state.CargoBulk &&
  //   //   this.state.CargoBulk?.Questions?.map((i, ind) =>
  //   //     ind < 18
  //   //       ? i.AnswersList1?.map((a) =>
  //   //           a?.AnswerLookupList[0]?.Answer != "" &&
  //   //           a?.AnswerLookupList[0]?.Answer > 0
  //   //             ? a.CategoryName === "Capacity (m³) Bale"
  //   //               ? (this.state.baleCapacity += parseInt(
  //   //                   a?.AnswerLookupList[0]?.Answer
  //   //                 ))
  //   //               : a.CategoryName === "Capacity (m³) Grain"
  //   //               ? (this.state.grainCapacity += parseInt(
  //   //                   a?.AnswerLookupList[0]?.Answer
  //   //                 ))
  //   //               : a.CategoryName === "Location Frame"
  //   //               ? (this.state.locationFrame += parseInt(
  //   //                   a?.AnswerLookupList[0]?.Answer
  //   //                 ))
  //   //               : 0
  //   //             : 0
  //   //         )
  //   //       : ""
  //   //   );
  //   console.log(this.state.NewQuestions.length, "length");
  //   this.state.CargoBulk &&
  //     this.state.CargoBulk?.Questions?.map((i, ind) =>
  //       this.state.NewQuestions.length > 0
  //         ? ind < this.state.NewQuestions.length
  //           ? i.AnswersList1?.map((a) =>
  //               a?.AnswerLookupList[0]?.Answer != "" &&
  //               a?.AnswerLookupList[0]?.Answer > 0
  //                 ? a.CategoryName === "Capacity (m³) Bale"
  //                   ? (baleCapacity += parseInt(a?.AnswerLookupList[0]?.Answer))
  //                   : a.CategoryName === "Capacity (m³) Grain"
  //                   ? (grainCapacity += parseInt(
  //                       a?.AnswerLookupList[0]?.Answer
  //                     ))
  //                   : a.CategoryName === "Location Frame"
  //                   ? (locationFrame += parseInt(
  //                       a?.AnswerLookupList[0]?.Answer
  //                     ))
  //                   : 0
  //                 : 0
  //             )
  //           : ""
  //         : ind < 18
  //         ? i.AnswersList1?.map((a) =>
  //             a?.AnswerLookupList[0]?.Answer != "" &&
  //             a?.AnswerLookupList[0]?.Answer > 0
  //               ? a.CategoryName === "Capacity (m³) Bale"
  //                 ? (baleCapacity += parseInt(a?.AnswerLookupList[0]?.Answer))
  //                 : a.CategoryName === "Capacity (m³) Grain"
  //                 ? (grainCapacity += parseInt(a?.AnswerLookupList[0]?.Answer))
  //                 : a.CategoryName === "Location Frame"
  //                 ? (locationFrame += parseInt(a?.AnswerLookupList[0]?.Answer))
  //                 : 0
  //               : 0
  //           )
  //         : ""
  //     );

  //   this.setState({
  //     baleCapacity: baleCapacity,
  //     grainCapacity: grainCapacity,
  //     locationFrame: locationFrame,
  //   },()=>{console.log(this.state.CargoBulk.Questions[9])});
  // };

  updatemastercomments2 = (e, str, Id, AnswerId) => {
    console.log(AnswerId);
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: AnswerId === null || AnswerId === undefined ? 0 : AnswerId,
      AnswerCategory: Id,
      Answer: e.target.value.trim(),
      MultipleAnswerIds: "",
      CreatedBy: this.state.User,
    };
    if (data.Id === 0) {
      this.post_bulkerStatus(data);
    } else {
      this.put_bulkerStatus(data, data.Id);
    }
  };

  AddCancel1 = () => {
    this.props.navigate(`/shiplist`);
  };

  render() {
    let { classes, menuToggle } = this.props;

    return (
      <>
        {this.state.isMobile ? (
          <>
            <div className="row w-100 border-bottom mt-4 mob-topfixed">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"TRAIN" + "1"}
                      className="  textNaviIcon"
                      primary="Inspection Tasks"
                    />
                    <NavigateNextIcon
                      id="TRAIN"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Vessel Capabilities and Cargo Systems Bulker </h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      class="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <table className="dataTable" width="100%">
                <tbody>
                  <tr>
                    <td width="5%" className="border-right text-center">
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.AddCancel1}
                      ></i>
                    </td>
                    <td className="" width="95%"></td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <div
            className="row"
            style={{ margin: this.state.isMobile ? "" : "5px" }}
          >
            <div className="row px-3">
              <div className="col-12 pt-2">
                {this.state.isMobile ? (
                  <></>
                ) : (
                  <h6>Vessel Capabilities and Cargo Systems Bulker</h6>
                )}
              </div>
            </div>
            <div
              className={`row mt-3 mx-1 mb-3 align-items-center p-0 ${
                this.state.isMobile ? "" : " "
              }`}
            >
              <div
                className={`table-responsive ${
                  this.state.isMobile ? "" : "p-0"
                }`}
                style={{ width: "100%" }}
              >
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right"
                >
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="6">
                        <span className="spandoc-thead">
                          Vessel Capabilities and Cargo System Bulk - Conditions
                        </span>
                      </th>
                    </tr>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right"></th>
                      <th>Cargo Hold</th>
                      <th className="border-right border-left">
                        <span className="spandoc-thead">
                          Capacity (m³) Bale
                        </span>
                      </th>
                      <th className="border-right border-left">
                        <span className="spandoc-thead">
                          Capacity (m³) Grain
                        </span>
                      </th>
                      <th className="border-left" colSpan="2">
                        <span className="spandoc-thead">Location Frame</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.CargoBulk &&
                      this.state.CargoBulk?.Questions?.map((i, ind) => {
                        const showPlusIcon =
                          this.state.UserRole == Role.Admin &&
                          this.state.NewQuestions.length
                            ? ind < this.state.NewQuestions.length &&
                              ind % 2 !== 0
                            : this.state.UserRole == Role.Admin &&
                              ind < 18 &&
                              ind % 2 !== 0;
                        const hideAdd = this.state.NewQuestions.length
                          ? this.state.NewQuestions.length == 18
                          : true;
                        const hideDelete = this.state.NewQuestions.length
                          ? this.state.NewQuestions.length < 5
                          : false;
                        return (
                          <>
                            <tr
                              className="border-top cargobulker"
                              onMouseEnter={() =>
                                this.setState({
                                  HoverId: i.Id,
                                })
                              }
                              onMouseLeave={() => this.setState({ HoverId: 0 })}
                              style={{ position: "relative" }}
                            >
                              <td
                                width="5%"
                                className="border-right text-center align-middle"
                                onMouseEnter={() =>
                                  this.setState({
                                    HoverId: i.Id,
                                    currentQuesId: i.QuestionId,
                                  })
                                }
                                onMouseLeave={() =>
                                  this.setState({
                                    HoverId: 0,
                                    currentQuesId: 0,
                                  })
                                }
                              >
                                <span className="spandoc-td">{ind + 1}</span>
                                {/* <span className="spandoc-td">{i.OrderId}</span> */}
                              </td>
                              <td
                                className={`${
                                  window.innerWidth < 1080
                                    ? "docwidthmobile-td"
                                    : "docwidth-td"
                                } border-right align-middle`}
                                width="50%"
                                
                              >
                                <span className="spandoc-td" style={{position:'relative'}}>
                                  <div
                                    onMouseEnter={() =>
                                      this.setState({
                                        HoverId: i.Id,
                                        currentQuesId: i.QuestionId,
                                      })
                                    }
                                    onMouseLeave={() =>
                                      this.setState({
                                        HoverId: 0,
                                        currentQuesId: 0,
                                      })
                                    }
                                    style={{
                                      position: "absolute",
                                      left: "-12px",
                                      right: "0",
                                      height: "50px",
                                      width:'25px',
                                      top:"10px",
                                      background: "transparent",
                                      zIndex: 1, // below icons, still triggers hover
                                    }}
                                  ></div>
                                  {i.QuestionDescription}
                                </span>
                                {showPlusIcon &&
                                  (this.state.currentQuesId == i.QuestionId ||
                                    this.state.currentQuesId ==
                                      this.state.CargoBulk.Questions[ind - 1]
                                        .QuestionId) && (
                                    // <i
                                    //   className="fa fa-plus d-flex align-items-center justify-content-center"
                                    //   style={{
                                    //     color: "#499AC8",
                                    //     position: "absolute",
                                    //     bottom: "-13px",
                                    //     left: "2px",
                                    //     fontSize: "16px",
                                    //     cursor: "pointer",
                                    //     background: "#fff",
                                    //     width: "28px",
                                    //     height: "28px",
                                    //     lineHeight: "20px",
                                    //     textAlign: "center",
                                    //     borderRadius: "50%",
                                    //     boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                    //     zIndex: 2,
                                    //     display: "inline-block",
                                    //   }}
                                    //   onClick={() => this.handleAddHold(i)}
                                    // ></i>
                                    // <>
                                    //   <span
                                    //     style={{
                                    //       position: "absolute",
                                    //       bottom: "-13px",
                                    //       left: "2px",
                                    //       display: "flex",
                                    //       alignItems: "center",
                                    //       justifyContent: "center",
                                    //       width: "42px",
                                    //       height: "26px",
                                    //       background: "#fff",
                                    //       color: "#499AC8",
                                    //       fontSize: "16px",
                                    //       borderRadius: "6px",
                                    //       boxShadow: "5px 3px 28px -5px rgba(0,0,0,0.53)",
                                    //       cursor: "pointer",
                                    //       zIndex: 2,
                                    //     }}
                                    //     onClick={() => this.handleAddHold(i)}
                                    //   >
                                    //     <i className="fa fa-plus"></i>
                                    //   </span>
                                    //   <i
                                    //     className="fa fa-play"
                                    //     style={{
                                    //       position: "absolute",
                                    //       bottom: "-8px",
                                    //       left: "43px",
                                    //       fontSize: "16px",
                                    //       color: "#fff",
                                    //       transform: "rotate(0deg)",
                                    //       zIndex: 5,
                                    //     }}
                                    //   ></i>
                                    // </>
                                    <div
                                      onMouseEnter={() =>
                                        this.setState({
                                          HoverId: i.Id,
                                          currentQuesId: i.QuestionId,
                                        })
                                      }
                                      onMouseLeave={() =>
                                        this.setState({
                                          HoverId: 0,
                                          currentQuesId: 0,
                                        })
                                      }
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "-25px", // 👈 25px of extra hover area above
                                          left: "0",
                                          right: "0",
                                          height: "30px",
                                          background: "transparent",
                                          zIndex: 1, // below icons, still triggers hover
                                        }}
                                      ></div>
                                      {/* First bubble with right-pointing arrow */}
                                      <Tooltip
                                        title={"Add Cargo Hold"}
                                        placement="top"
                                        arrow
                                      >
                                        <span
                                          style={{
                                            position: "absolute",
                                            bottom: "-12px",
                                            left: "2px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "36px",
                                            height: "24px",
                                            background: "#fff",
                                            color: "#499AC8",
                                            fontSize: "16px",
                                            borderRadius: "6px",
                                            boxShadow:
                                              "5px 3px 28px -5px rgba(0,0,0,0.53)",
                                            cursor: "pointer",
                                            zIndex: 2,
                                          }}
                                          onClick={() => {
                                            if (!hideAdd) {
                                              this.openAddModal();
                                            } else {
                                              this.setState({
                                                isErrorPopup: true,
                                                errorMessage:
                                                  "Maximum cargo hold limit reached",
                                              });
                                            }
                                          }}
                                        >
                                          <i className="fa fa-plus"></i>
                                        </span>
                                      </Tooltip>
                                      <i
                                        className="fa fa-play"
                                        style={{
                                          position: "absolute",
                                          bottom: "-8px",
                                          left: "37px",
                                          fontSize: "15px",
                                          color: "#fff",
                                          transform: "rotate(0deg)",
                                          zIndex: 5,
                                        }}
                                      ></i>
                                      <Tooltip
                                        title={"Delete Cargo Hold"}
                                        placement="top"
                                        arrow
                                      >
                                        <span
                                          style={{
                                            position: "absolute",
                                            bottom: "-12px",
                                            left: "62px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "36px",
                                            height: "24px",
                                            background: "#fff",
                                            color: "#499AC8",
                                            fontSize: "16px",
                                            borderRadius: "6px",
                                            boxShadow:
                                              "-5px 3px 28px -5px rgba(0,0,0,0.53)",
                                            cursor: "pointer",
                                            zIndex: 2,
                                          }}
                                          onClick={() => {
                                            if (!hideDelete) {
                                              this.handleDelete(
                                                i.QuestionId,
                                                ind
                                              );
                                            } else {
                                              this.setState({
                                                isErrorPopup: true,
                                                errorMessage:
                                                  "Atleast two cargo hold is mandatory",
                                              });
                                            }
                                          }}
                                        >
                                          <i
                                            className="fa fa-trash-o"
                                            style={{ color: "#ff0000" }}
                                          ></i>
                                        </span>
                                      </Tooltip>
                                      <i
                                        className="fa fa-play"
                                        style={{
                                          position: "absolute",
                                          bottom: "-7px",
                                          left: "50px",
                                          fontSize: "15px",
                                          color: "#fff",
                                          transform: "rotate(180deg)",
                                          zIndex: 5,
                                        }}
                                      ></i>
                                    </div>
                                  )}
                              </td>

                              {i.AnswerType === 11 ? (
                                <>
                                  {i?.AnswerLookupList != null &&
                                  i?.AnswerLookupList?.length > 0 ? (
                                    <>
                                      <td
                                        className="spanstatusnormal-thead align-middle"
                                        colSpan={3}
                                      >
                                        <div className="spandoc-td">
                                          {i.AnswerLookupList.map(
                                            (v_i, index) => (
                                              <label
                                                style={{
                                                  color: "#000000",
                                                  padding: 5,
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  className="checkboxradio"
                                                  name={`muhRadio${i.QuestionId}`}
                                                  id={`Generalyes${i.QuestionId}`}
                                                  checked={
                                                    v_i.Id == i.CheckId
                                                      ? true
                                                      : false
                                                  }
                                                  value={v_i.Id}
                                                  onClick={(e) => {
                                                    this.handleInputChange(
                                                      e,
                                                      i
                                                    );
                                                  }}
                                                  style={{
                                                    color:
                                                      "rgba(0, 0, 0, 0.54)",
                                                  }}
                                                />
                                                <span
                                                  className="checkboxtext"
                                                  style={{
                                                    verticalAlign: "top",
                                                  }}
                                                >
                                                  {v_i.Answer}
                                                </span>
                                              </label>
                                            )
                                          )}
                                        </div>
                                      </td>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : //  : i.QuestionDescription === "No 1 Lower Hold" ||
                              //   i.QuestionDescription === "No 1 Upper Hold" ||
                              //   i.QuestionDescription === "No 2 Lower Hold" ||
                              //   i.QuestionDescription === "No 2 Upper Hold" ||
                              //   i.QuestionDescription === "No 3 Lower Hold" ||
                              //   i.QuestionDescription === "No 3 Upper Hold" ||
                              //   i.QuestionDescription === "No 4 Lower Hold" ||
                              //   i.QuestionDescription === "No 4 Upper Hold" ||
                              //   i.QuestionDescription === "No 5 Lower Hold" ||
                              //   i.QuestionDescription === "No 5 Upper Hold" ?
                              /^No [1-9] (Lower|Upper) Hold$/.test(
                                  i.QuestionDescription
                                ) ? (
                                <>
                                  <td className=" commentsrequire-td2 align-middle border-right">
                                    <span className="spandoc-td">
                                      <CssTextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        onChange={(e) =>
                                          this.handleInputChange2(
                                            e,
                                            i,
                                            i?.AnswersList[0]?.CategoryId,
                                            i?.AnswersList[0]?.CategoryName
                                          )
                                        }
                                        onBlur={(e) =>
                                          this.updatemastercomments2(
                                            e,
                                            i,
                                            i?.AnswersList[0]?.CategoryId,
                                            i?.AnswersList1?.filter(
                                              (j) =>
                                                j.CategoryName ===
                                                "Capacity (m³) Bale"
                                            )[0]?.AnswerLookupList[0].Id
                                          )
                                        }
                                        value={
                                          i?.AnswersList1 != null &&
                                          i?.AnswersList1?.filter(
                                            (j) =>
                                              j.CategoryName ===
                                              "Capacity (m³) Bale"
                                          )[0]?.AnswerLookupList[0]?.Answer
                                            ? i?.AnswersList1?.filter(
                                                (j) =>
                                                  j.CategoryName ===
                                                  "Capacity (m³) Bale"
                                              )[0]?.AnswerLookupList[0]?.Answer
                                            : ""
                                        }
                                        InputProps={{
                                          className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                        }}
                                      />
                                    </span>
                                  </td>
                                  <td className=" commentsrequire-td2 align-middle border-right">
                                    <span className="spandoc-td">
                                      <CssTextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        onChange={(e) =>
                                          this.handleInputChange2(
                                            e,
                                            i,
                                            i?.AnswersList[1]?.CategoryId,
                                            i?.AnswersList[1]?.CategoryName
                                          )
                                        }
                                        onBlur={(e) =>
                                          this.updatemastercomments2(
                                            e,
                                            i,
                                            i?.AnswersList[1]?.CategoryId,
                                            i?.AnswersList1?.filter(
                                              (j) =>
                                                j.CategoryName ===
                                                "Capacity (m³) Grain"
                                            )[0]?.AnswerLookupList[0].Id
                                          )
                                        }
                                        value={
                                          i?.AnswersList1 != null &&
                                          i?.AnswersList1?.filter(
                                            (j) =>
                                              j.CategoryName ===
                                              "Capacity (m³) Grain"
                                          )[0]?.AnswerLookupList[0]?.Answer
                                            ? i?.AnswersList1?.filter(
                                                (j) =>
                                                  j.CategoryName ===
                                                  "Capacity (m³) Grain"
                                              )[0]?.AnswerLookupList[0]?.Answer
                                            : ""
                                        }
                                        InputProps={{
                                          className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                        }}
                                      />
                                    </span>
                                  </td>
                                  <td className=" commentsrequire-td2 align-middle">
                                    <span className="spandoc-td">
                                      <CssTextField
                                        multiline
                                        fullWidth
                                        variant="outlined"
                                        type="number"
                                        onChange={(e) =>
                                          this.handleInputChange2(
                                            e,
                                            i,
                                            i?.AnswersList[2]?.CategoryId,
                                            i?.AnswersList[2]?.CategoryName
                                          )
                                        }
                                        onBlur={(e) =>
                                          this.updatemastercomments2(
                                            e,
                                            i,
                                            i?.AnswersList[2]?.CategoryId,
                                            i?.AnswersList1?.filter(
                                              (j) =>
                                                j.CategoryName ===
                                                "Location Frame"
                                            )[0]?.AnswerLookupList[0].Id
                                          )
                                        }
                                        value={
                                          i?.AnswersList1 != null &&
                                          i?.AnswersList1?.filter(
                                            (j) =>
                                              j.CategoryName ===
                                              "Location Frame"
                                          )[0]?.AnswerLookupList[0]?.Answer
                                            ? i?.AnswersList1?.filter(
                                                (j) =>
                                                  j.CategoryName ===
                                                  "Location Frame"
                                              )[0]?.AnswerLookupList[0]?.Answer
                                            : ""
                                        }
                                        InputProps={{
                                          className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                        }}
                                      />
                                    </span>
                                  </td>
                                </>
                              ) : i.QuestionDescription === "Total" ? (
                                <>
                                  <td className=" commentsrequire-td2 align-middle border-right">
                                    <span className="spandoc-td">
                                      {this.state.baleCapacity &&
                                        this.state.baleCapacity}
                                    </span>
                                  </td>
                                  <td className=" commentsrequire-td2 align-middle border-right">
                                    <span className="spandoc-td">
                                      {this.state.grainCapacity &&
                                        this.state.grainCapacity}
                                    </span>
                                  </td>
                                  <td className=" commentsrequire-td2 align-middle">
                                    <span className="spandoc-td">
                                      {this.state.locationFrame &&
                                        this.state.locationFrame}
                                    </span>
                                  </td>
                                </>
                              ) : (
                                <td
                                  className="commentsrequire-td align-middle"
                                  colSpan={3}
                                >
                                  <span className="spandoc-td">
                                    <CssTextField
                                      multiline
                                      fullWidth
                                      variant="outlined"
                                      type="text"
                                      onChange={(e) =>
                                        this.handleInputChange1(e, i)
                                      }
                                      onBlur={(e) =>
                                        this.updatemastercomments(e, i)
                                      }
                                      value={i?.Answer}
                                      InputProps={{
                                        className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                      }}
                                    />
                                  </span>
                                </td>
                              )}
                              <td
                                width="4%"
                                className="border-right text-center align-middle"
                              >
                                {i.QuestionId === this.state.successId &&
                                this.state.isSuccess === true ? (
                                  <span className="spandoc-success-img">
                                    <img
                                      src={successIcon}
                                      className="success-error-img"
                                    />
                                  </span>
                                ) : null}
                                {i.QuestionId === this.state.successId &&
                                this.state.isFailure === true ? (
                                  <span className="spandoc-error-img">
                                    <img
                                      src={errorIcon}
                                      className="success-error-img"
                                    />
                                  </span>
                                ) : null}{" "}
                              </td>
                            </tr>{" "}
                          </>
                        );
                      })}
                    <tr className="border-right border-top text-center align-middle">
                      <td colSpan={5}>
                        <label
                          className={
                            this.state.isMobile
                              ? "d-flex pt-2 m-0 mb-1 spandoc-thead"
                              : "mb-1 spandoc-thead form-group m-0 float-start text-left"
                          }
                        >
                          Comments&nbsp;:
                        </label>
                        <TextField
                          multiline
                          minRows={5}
                          variant="outlined"
                          size="small"
                          fullWidth
                          InputProps={{
                            className: `border-radius mt-1 ${classes.inputfieldAlign}`,
                            style: { fontSize: 12 },
                          }}
                          value={this.state.CargoBulkComments}
                          type="text"
                          onChange={(e) =>
                            this.handleInputCommentChange(e, "CargoBulk")
                          }
                          onBlur={(e) =>
                            this.updateOperationalComments(e, "CargoBulk")
                          }
                        />
                      </td>
                      <td
                        width="4%"
                        className="border-right text-center align-middle"
                      >
                        {"CargoBulk" === this.state.CommentId &&
                        this.state.isSuccessComment === true ? (
                          <span className="spandoc-success-img">
                            <img
                              src={successIcon}
                              className="success-error-img"
                            />
                          </span>
                        ) : null}
                        {"CargoBulk" === this.state.CommentId &&
                        this.state.isFailureComment === true ? (
                          <span className="spandoc-error-img">
                            <img
                              src={errorIcon}
                              className="success-error-img"
                            />
                          </span>
                        ) : null}{" "}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade ${
            this.state.isErrorPopup ? "show d-block" : ""
          }`}
          id="deletepopup"
          tabindex="-1"
          role="dialog"
          aria-labelledby="deletepopupLabel"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
            top: "0px",
          }}
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-3">
              <div class="modal-body pb-0">
                <h1 className="text-center">
                  <img src={del}></img>
                </h1>
                <div className="text-center">
                  <h5 class="fw-bold">{this.state.errorMessage}</h5>{" "}
                </div>
              </div>
              <div
                className="modal-footer m-auto"
                style={{ borderTop: "none" }}
              >
                <button
                  className="btn btn-secondary py-2 px-4"
                  style={{ backgroundColor: "#499AC8", border: "none" }}
                  onClick={() => {
                    this.setState({ isErrorPopup: false, errorMessage: "" });
                  }}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade ${
            this.state.isDeleteModal ? "show d-block" : ""
          }`}
          id="deletepopup"
          tabindex="-1"
          role="dialog"
          aria-labelledby="deletepopupLabel"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
            top: "0px",
          }}
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-3">
              <div class="modal-body pb-0">
                <h1 className="text-center">
                  <img src={del}></img>
                </h1>
                <div className="text-center">
                  <h5 class="fw-bold">Are you sure you want to delete?</h5>{" "}
                </div>
              </div>
              <div class="modal-footer border-top-0 m-auto">
                <button
                  type="button"
                  className="btn btn-secondary py-2 px-4"
                  data-dismiss="modal"
                  style={{ backgroundColor: "#499AC8", border: "none" }}
                  onClick={() => {
                    this.deleteFunction();
                  }}
                >
                  <span className="">Delete</span>
                </button>
                <button
                  type="button"
                  className="btn btn-secondary py-2 px-4"
                  id="closemodal1"
                  onClick={() => {
                    this.closeDeleteModal();
                  }}
                  style={{
                    backgroundColor: "#EBEBEB",
                    border: "none",
                    color: "#111010",
                  }}
                >
                  <span className="">Cancel</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`modal fade ${
            this.state.isAddModal ? "show d-block" : ""
          }`}
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 2000,
            top: "0px",
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h5 className="modal-title">Cargo Hold</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={this.closeAddModal}
                ></button>
              </div>

              <div className="modal-body pt-2">
                <div className="row align-items-center">
                  {/* <div className="col-12 m-auto">
                    <label htmlFor="reportStatus">Cargo Hold</label>
                  </div> */}
                  <div className="col-12">
                    {/* <select
                      id="reportStatus"
                      className={`form-control border-radius ${
                        this.state.cargoAddError ? "border-danger" : ""
                      }`}
                      value={JSON.stringify(this.state.selectedCargo) || ""}
                      onChange={(e) => {
                        // Parse the selected value which contains QuestionIds
                        const selectedOption = e.target.value
                          ? JSON.parse(e.target.value)
                          : null;
                        this.handleAddCargoChange(selectedOption);
                      }}
                    >
                      <option value={""}>Select Cargo Hold</option>
                      {this.state.addCargoOptions &&
                        this.state.addCargoOptions.map((i, idx) => (
                          <option key={idx} value={JSON.stringify(i)}>
                            {i.name}
                          </option>
                        ))}
                    </select> */}
                    <Autocomplete
                      getItemValue={(item) => item.name}
                      items={this.state.addCargoOptions || []}
                      renderItem={(item, isHighlighted) => (
                        <div
                          key={item.name}
                          style={{
                            background: isHighlighted ? "#f0f0f0" : "#fff",
                            padding: "8px 10px",
                            cursor: "pointer",
                          }}
                        >
                          {item.name}
                        </div>
                      )}
                      value={this.state.selectedCargo?.name || ""}
                      onChange={() => {}} // disable typing
                      onSelect={(val, item) => this.handleAddCargoChange(item)}
                      wrapperStyle={{
                        width: "100%",
                        position: "relative",
                      }}
                      menuStyle={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        backgroundColor: "#fff",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                        maxHeight: "150px",
                        overflowY: "auto",
                        fontSize: "12px",
                        zIndex: 2500, // stays above modal content but inside modal
                      }}
                      inputProps={{
                        className: `form-control border-radius ${
                          this.state.cargoAddError ? "border-danger" : ""
                        }`,
                        placeholder: "Select Cargo Hold",
                        // style: { cursor: "pointer" },
                        style: {
                          height: 36,
                          fontSize: 12,
                          color: "#000000",
                        },
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="modal-footer" style={{ borderTop: "none" }}>
                <button
                  className="btn btn-secondary py-2 px-4"
                  style={{ backgroundColor: "#499AC8", border: "none" }}
                  onClick={() => {
                    this.handleAddCargo();
                  }}
                >
                  Add
                </button>
                <button
                  type="button"
                  className=" btn btn-secondary py-2 px-4"
                  style={{
                    backgroundColor: "#EBEBEB",
                    border: "none",
                    color: "#111010",
                  }}
                  onClick={() => {
                    this.closeAddModal();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(AddEditCargoBulker))
);
